import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import Translate from 'react-translate-component';
import SvgCalendar from '../../svg/calendar';
import SvgCashSek from '../../svg/cash-sek';
import SvgUser from '../../svg/user';

class ConfirmModal extends React.Component {

  static propTypes = {
    callback: PropTypes.func.isRequired,
    amount: PropTypes.string,
    firstWorkDate: PropTypes.string,
    lastWorkDate: PropTypes.string,
    customer: PropTypes.object
  };

  constructor (props) {
    super(props);

    this.state = {
      open: true
    };
  }

  confirm = () => {
    this.props.callback(true);
  }

  reject = () => {
    this.props.callback(false);
  }

  render = () => {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen={this.state.open}
        onRequestClose={this.reject}>
        <div className='modal-content confirm-preregister-modal'>
          <button className='close' onClick={this.reject}></button>
          <div>
            <h2 className='confirm-preregister-modal-title'>
              <Translate content='CONFIRM_PREREGISTER_MODAL_TITLE'/>
            </h2>
            <p className='confirm-preregister-modal-text'>
              <Translate content='CONFIRM_PREREGISTER_MODAL_TEXT'/>
            </p>
            <ul className='confirm-preregister-modal-infolist'>
              <li>
                <div className='infolist-icon'>
                  <SvgUser
                    width='30'
                    height='30'
                    colorSchema='primary'
                  />
                </div>
                {this.props.customer.name}
              </li>
              <li>
                <div className='infolist-icon'>
                  <SvgCashSek
                    width='30'
                    height='30'
                    colorSchema='primary'
                  />
                </div>
                {this.props.amount} <span className='infolist-lowercase'>
                  <Translate content='EXCL_VAT'/>
                </span>
              </li>
              <li>
                <div className='infolist-icon'>
                  <SvgCalendar
                    width='30'
                    height='30'
                    colorSchema='primary'
                  />
                </div>
                {this.props.firstWorkDate}&nbsp;
                <Translate content='CONFIRM_PREREGISTER_MODAL_PERIOD_TO'/>&nbsp;
                {this.props.lastWorkDate}
              </li>
            </ul>
          </div>
          <div className="confirm-preregister-modal-btn-wrapper">
            <button className="btn" onClick={this.confirm}>
              <Translate content='CONFIRM_PREREGISTER_MODAL_SUBMIT'/>
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ConfirmModal;



/** WEBPACK FOOTER **
 ** ./src/components/modal/confirm-preregister-modal/confirm-preregister-modal.js
 **/